var _ellipse, _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.6583,
    cy: 47.9977,
    rx: 21.7018,
    ry: 4.50263,
    fill: "#93B9FF",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.11182,
    y: 18.4971,
    width: 42.4735,
    height: 30.2763,
    rx: 7.425,
    fill: "url(#paint0_linear_98_36981)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3987 18.4974C47.0219 18.6092 49.2927 20.082 50.523 22.2277L35.8069 31.5069L31.4989 35.0779C31.2399 35.2951 30.913 35.4141 30.5753 35.4141C30.2375 35.4141 29.9106 35.2951 29.6516 35.0779L25.3437 31.5075L10.0143 22.2161C11.2461 20.0767 13.5135 18.609 16.132 18.4974L44.3987 18.4974Z",
    fill: "url(#paint1_linear_98_36981)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0718 13.2C14.0718 10.4662 16.288 8.25 19.0218 8.25H41.6745C44.4083 8.25 46.6245 10.4662 46.6245 13.2V24.8355L30.5031 35.8868L14.0718 24.8355V13.2Z",
    fill: "url(#paint2_linear_98_36981)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0713 21.6865V24.9117L30.5026 35.8862L46.624 24.9117V21.6865L30.5026 32.936L14.0713 21.6865Z",
    fill: "url(#paint3_linear_98_36981)",
    fillOpacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.083 29.6606C31.6817 29.3215 31.1751 29.1357 30.6517 29.1357C30.1284 29.1357 29.6218 29.3215 29.2205 29.6606L22.545 35.2365L11.8196 44.1342C10.3602 45.3449 11.2163 47.7177 13.1125 47.7177H47.259C49.1103 47.7177 49.9909 45.4385 48.6205 44.1937L38.7585 35.2355L32.083 29.6606Z",
    fill: "url(#paint4_linear_98_36981)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2145 48.7673C14.5354 48.6957 13.0006 48.0665 11.7908 47.0602L25.4264 35.7578L29.7344 32.1867C29.9933 31.9696 30.3203 31.8506 30.658 31.8506C30.9957 31.8506 31.3227 31.9696 31.5817 32.1867L35.8896 35.7572L49.206 46.7956C47.9547 47.9556 46.3028 48.6897 44.4811 48.7673H16.2145Z",
    fill: "url(#paint5_linear_98_36981)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.36 18.6286C35.1324 20.4056 35.108 23.2547 33.3707 25.0046C33.3674 25.0081 33.3635 25.012 33.36 25.0156L31.3665 27.0122C29.6083 28.7733 26.7478 28.7731 24.9898 27.0122C23.2316 25.2515 23.2316 22.386 24.9898 20.6252L26.0905 19.5227C26.3824 19.2304 26.8851 19.4247 26.9002 19.8379C26.9194 20.3644 27.0137 20.8935 27.1877 21.4043C27.2466 21.5773 27.2045 21.7687 27.0754 21.8979L26.6872 22.2868C25.8558 23.1195 25.8298 24.4754 26.653 25.3162C27.4843 26.1654 28.8507 26.1705 29.6884 25.3314L31.6819 23.335C32.5181 22.4974 32.5146 21.1435 31.6819 20.3094C31.5721 20.1996 31.4615 20.1144 31.3751 20.0548C31.314 20.0128 31.2635 19.957 31.2277 19.892C31.192 19.8269 31.1719 19.7544 31.169 19.6802C31.1573 19.3663 31.2683 19.0427 31.516 18.7946L32.1406 18.169C32.3044 18.005 32.5613 17.9848 32.7512 18.1176C32.9687 18.2697 33.1724 18.4407 33.36 18.6286ZM37.5408 14.4408C35.7828 12.68 32.9223 12.6798 31.1641 14.4408L29.1706 16.4375C29.167 16.4411 29.1632 16.4449 29.1599 16.4485C27.4226 18.1983 27.3982 21.0474 29.1706 22.8245C29.3582 23.0124 29.5619 23.1833 29.7793 23.3354C29.9693 23.4682 30.2262 23.448 30.39 23.284L31.0145 22.6584C31.2622 22.4103 31.3733 22.0868 31.3615 21.7728C31.3587 21.6986 31.3386 21.6261 31.3028 21.5611C31.267 21.496 31.2166 21.4403 31.1555 21.3982C31.0691 21.3387 30.9585 21.2534 30.8487 21.1436C30.0159 20.3095 30.0124 18.9556 30.8487 18.118L32.8422 16.1216C33.6799 15.2826 35.0462 15.2876 35.8776 16.1368C36.7008 16.9776 36.6747 18.3335 35.8433 19.1663L35.4551 19.5551C35.3261 19.6844 35.284 19.8757 35.3429 20.0487C35.5168 20.5596 35.6111 21.0886 35.6303 21.6152C35.6454 22.0284 36.1481 22.2227 36.44 21.9303L37.5407 20.8278C39.299 19.0671 39.299 16.2016 37.5408 14.4408Z",
    fill: "url(#paint6_linear_98_36981)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_36981",
    x1: 30.3486,
    y1: 18.4971,
    x2: 30.3486,
    y2: 48.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656102,
    stopColor: "#83AEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5191FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_98_36981",
    x1: 30.2686,
    y1: 35.4141,
    x2: 30.2686,
    y2: 18.4974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2675FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5492FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_98_36981",
    x1: 30.3481,
    y1: 8.25,
    x2: 30.3481,
    y2: 35.8868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526554,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEDFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_98_36981",
    x1: 30.421,
    y1: 7.39856,
    x2: 30.3646,
    y2: 35.8861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4987F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_98_36981",
    x1: 29.9617,
    y1: 61.155,
    x2: 28.8849,
    y2: 31.0555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E8EFF",
    stopOpacity: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E8EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_98_36981",
    x1: 30.2055,
    y1: 31.8506,
    x2: 30.2055,
    y2: 48.7673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACCAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_98_36981",
    x1: 26.2821,
    y1: 27.293,
    x2: 25.9745,
    y2: -2.42267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD357"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.d2d714102167fdcd6f79aa8f1c478d1b.svg";
export { ForwardRef as ReactComponent };